import React from "react";
import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image";
import { CmsNode } from "@components/CMS/CmsTypes";

type CmsFeaturedImageProps = {
	className?: string;
	node: CmsNode;
};
export default function CmsFeaturedImage({
	className,
	node,
}: CmsFeaturedImageProps) {
	if (!node.relationships.field_feature_image.field_media_image) {
		node.relationships.field_feature_image.field_media_image = {
			alt: "",
		};
	}
	const {
		relationships: {
			field_feature_image: {
				relationships: {
					field_media_image: { localFile },
				},
				field_media_image: { alt },
			},
		},
	} = node;
	const image = getImage(localFile) as IGatsbyImageData;
	return (
		<GatsbyImage
			className={className}
			image={image}
			alt={alt}
			loading="eager"
		/>
	);
}
